import { TEXT_KEY, getText } from '../../../../../utils/localization';
export var LANGUAGE_DEFAULT = 'en';
export var localizationOptions = [{
  label: getText(TEXT_KEY.LOCALIZATION_ENGLISH_LABEL),
  value: 'en'
}, {
  label: getText(TEXT_KEY.LOCALIZATION_SPANISH_LABEL),
  value: 'es'
}];